import type { GlobalState } from '../index';

export const getPhoneConfirmationStatus = (state: GlobalState): string => state.authorization.phoneConfirmation.status;
export const getPhoneLoadingStatus = (state: GlobalState): boolean => state.authorization.phoneConfirmation.isLoading;

export const getSmsCodeStatusTimeout = (state: GlobalState): number => state.authorization.smsCodeStatus.timeout;
export const getSmsCodeStatusError = (state: GlobalState): string => state.authorization.smsCodeStatus.errorMessage;
